import React from 'react';
import DateFnsUtils from '@date-io/date-fns';

import { ArrowDropDown, ArrowDropUp } from '@material-ui/icons';
import { Box, Typography, Button, Popover, createMuiTheme } from '@material-ui/core'
import { useSelector } from 'react-redux';
import { darkTheme, lightTheme } from '../../layout/themes';
import { makeStyles, ThemeProvider, useTheme } from '@material-ui/core/styles'
import { useTranslate } from 'react-admin';
import { lightBlue, grey } from '@material-ui/core/colors';

import { MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers';
import TextButton from '../../CustomizedUIs/TextButton';

const useStyles = makeStyles((theme) => ({
    isOpenNotValue: {
        position: 'relative',
        color: '#237fc2',
        marginTop: 5,
        fontFamily: 'UniviaPro',
        fontSize: '11px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.36,
        letterSpacing: 'normal',
    },
    isOpen: {
        position: 'relative',
        marginTop: 5,
        color: '#88898c',
        fontFamily: 'UniviaPro',
        fontSize: '11px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.36,
        letterSpacing: 'normal',
    },
    notOpen: {
        color: '#88898c',
        bottom: 0,
        marginTop: 16,
        fontFamily: 'UniviaPro',
        fontSize: '11px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.36,
        letterSpacing: 'normal',
    },
    TitleDateTime: {
        fontFamily: 'UniviaPro-Bold',
        fontSize: '11px',
        fontWeight: 500,
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.2,
        letterSpacing: 'normal',
        color: '#4f5064',
    },
    Time: {
        fontFamily: 'UniviaPro',
        fontSize: '13px',
        fontWeight: 500,
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.25,
        letterSpacing: '0.13px',
        color: '#4f5064',
    },
    Date: {
        fontFamily: 'UniviaPro',
        fontSize: '13px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.85,
        letterSpacing: ' 0.13px',
        color: '#4f5064',
    },

    btnOk: {
        fontFamily: 'UniviaPro-Bold',
        fontSize: '11px',
        fontWeight: 'bold',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 'normal',
        letterSpacing: '0.44px',
        color: ' #237fc2',
    }

}));






export default function StartCalendar({ anchorEl, handleClick, handleClose, handleDateChange, value, date, finishPickDate, Title, ...props }) {
    const classes = useStyles();
    const translate = useTranslate();

    const open = Boolean(anchorEl);
    const id = open ? 'simple-popover' : undefined;

    const theme = useTheme()



    return (

        <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <div>
                <Box position='relative'
                    borderBottom={open ? 2 : 1}
                    style={{ cursor: 'pointer', borderBottomColor: open ? theme.palette.primary.main : (value === "" ? lightBlue['100'] : grey['900']) }}
                    height='51.92px'
                    bgcolor='background.paper'
                    display='flex'
                    width='100%'
                    onClick={handleClick}>
                    <Box flexGrow={1} pl="12px">
                        <Typography className={open ? classes.isOpenNotValue : (value !== "" ? classes.isOpen : classes.notOpen)}>
                            {Title}
                            {/* <sup style={{ fontSize: open || value !== "" ? 'smaller' : 'medium', position: 'absolute', marginLeft: 2 }}>*</sup> */}

                        </Typography>
                        {value !== "" && <Typography className={classes.Date}>{value}</Typography>}
                    </Box>
                    <Box my='auto' mr={2}>
                        {open ? <ArrowDropUp fontSize="large" style={{ color: theme.palette.primary.main }} /> : <ArrowDropDown fontSize="large" style={{ color:theme.palette.primary.main }} />}
                    </Box>

                </Box>
                <Popover
                    style={{ borderRadius: 0 }}
                    id={id}
                    open={open}
                    anchorEl={anchorEl}
                    onClose={handleClose}
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'right',
                    }}
                    transformOrigin={{
                        vertical: 'top',
                        horizontal: 'right',
                    }}
                >
                    <Box>
                        <KeyboardDatePicker
                            {...props}
                            variant="static"
                            value={date}
                            onChange={handleDateChange}
                            onClose={handleClose}
                            clearable
                        />
                        <Box display='flex' bgcolor='#f3f7fa' justifyContent='flex-end' py={2} height='100%'>
                            <Box display='flex' mt={3}>
                                <TextButton onClick={handleClose} />
                            </Box>
                        </Box>
                    </Box>

                </Popover>
            </div>
        </MuiPickersUtilsProvider>

    );
}